export default __webpack_public_path__ + "static/media/playlist-plus.311e1a88.svg";